import ptBrTranslations from './pt-br.json'

export default {
  'pt-BR': {
    translations: ptBrTranslations,
  },
}
